import React from "react";
import { TradingGlobalContext } from "../../context/TradingGlobalContext";
/**
 * 给context的default value，实际上是无效数据。初始化组件时就应该被外部真是值所覆盖
 */
export var DEFAULT_ACCOUNT_INFO = {
  isInitialized: false
};
export function useAccountInfo() {
  var _React$useContext = React.useContext(TradingGlobalContext),
    accountInfo = _React$useContext.accountInfo;
  return accountInfo;
}